<template>
  <div>
    <div class="container-fluid">
      <div class="row justify-content-around align-items-center">
        <div class="col-md-9">
          <vx-card>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-button icon="arrow_back" to="/users">{{$t('back')}}</vs-button>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="flex-end"
                vs-align="flex-end"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-button
                  icon="save"
                  :disabled="!validateForm"
                  @click="addUser"
                >{{ $t('save') }}</vs-button>
              </vs-col>
            </vs-row>
            <vs-row class="mt-5">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-row>
                  <vs-input
                    v-validate="'required|min:3'"
                    data-vv-validate-on="blur"
                    :name="$t('userName')"
                    v-model="obj.UserName"
                    class="w-full mt-8 mr-3"
                    :label-placeholder="$t('userName')"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('userName')) }}</span>
                </vs-row>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-row>
                  <vs-input
                    v-validate="'required|min:3'"
                    data-vv-validate-on="blur"
                    :name="$t('firstname')"
                    v-model="obj.FirstName"
                    class="w-full mt-8 mr-3"
                    :label-placeholder="$t('firstname')"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('firstname')) }}</span>
                </vs-row>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-row>
                  <vs-input
                    v-validate="'required|min:3'"
                    data-vv-validate-on="blur"
                    :name="$t('surname')"
                    v-model="obj.LastName"
                    class="w-full mt-8 mr-3"
                    :label-placeholder="$t('surname')"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('surname')) }}</span>
                </vs-row>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-row>
                  <vs-input
                    v-validate="'required|email|min:3'"
                    data-vv-validate-on="blur"
                    v-model="obj.Email"
                    :name="$t('email')"
                    class="w-full mt-8 mr-3"
                    :label-placeholder="$t('email')"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('email')) }}</span>
                </vs-row>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-row>
                  <vs-input
                    v-validate="'required|min:7|max:191'"
                    data-vv-validate-on="blur"
                    v-model="obj.UserPassword"
                    :name="$t('password')"
                    class="w-full mt-8 mr-3"
                    :label-placeholder="$t('password')"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('password')) }}</span>
                </vs-row>
              </vs-col>
            </vs-row>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";

export default {
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.obj.email != "" &&
        this.obj.UserName != "" &&
        this.obj.FirstName != "" &&
        this.obj.LastName != "" &&
        this.obj.UserPassword != ""
      );
    }
  },
  data() {
    return {
      obj: {
        UserName: "",
        FirstName: "",
        LastName: "",
        Email: "",
        UserPassword: ""
      }
    };
  },
  methods: {
    addUser() {
      let path = "/users/adduser";
      http.post(path, this.obj).then(response => {
        notify.success(response.message);
      });
    }
  }
};
</script>

<style>
</style>